const TRP_CLIENT_URL = process.env.REACT_APP_TRP_CLIENT_URL || 'https://opeva-clientes-trp-dev.jphlions.com';
const SERVICE_TOKEN = process.env.REACT_APP_TRP_SERVICE_TOKEN || '';
const TENANT_ID = process.env.REACT_APP_TENANT_ID || '';

const headers = {
  'x-service-token': SERVICE_TOKEN,
  'Content-Type': 'application/json',
};

const toolboxApiService = {
  async getTipoOperativos() {
    const res = await fetch(`${TRP_CLIENT_URL}/amarre/tipo-operativos`, { headers });
    const data = await res.json();
    return data.data || [];
  },

  async getLugares(tipoOperativo) {
    if (!tipoOperativo) return [];
    const res = await fetch(`${TRP_CLIENT_URL}/amarre/lugares?tipoOperativo=${tipoOperativo}`, { headers });
    const data = await res.json();
    return data.data || [];
  },

  async getParticipantes({ tipoOperativo, lugarOperativo, fecha }) {
    if (!tipoOperativo || !lugarOperativo || !fecha) return [];
    const params = new URLSearchParams({ tipoOperativo, lugarOperativo, fecha, tenant: TENANT_ID });
    const res = await fetch(`${TRP_CLIENT_URL}/toolbox/participantes?${params}`, { headers });
    const data = await res.json();
    return data.data || [];
  },
};

export default toolboxApiService;
